(() => {
  const template = document.querySelector('[data-hero-cta]');
  if (!template) return;
  const jobsTable = document.querySelector('#careers-jobs__table');
  if (!jobsTable) return;

  const sticky = document.createElement('div');
  sticky.className = 'careers-hero__sticky-cta';
  sticky.appendChild(template.content.cloneNode(true));

  // Append to <body> so position:fixed is always viewport-relative.
  document.body.appendChild(sticky);

  const footer = document.querySelector('footer');

  // Tracked separately per observer target and combined below — was a single
  // observer keyed only on the jobs table, so once the page scrolled PAST the
  // table (table's own bottom edge leaves the viewport, same as it leaving
  // from the top) `isIntersecting` flips back to false and the button
  // un-hides again, right as the footer scrolls in. The PDP's equivalent
  // sticky bar (assets/pdp-sidebar-ctas.js `_handleScroll`) already guards
  // this with an explicit footer check; mirrored here instead of inventing a
  // second pattern.
  let jobsTableVisible = false;
  let footerVisible = false;

  const syncVisibility = () => {
    sticky.classList.toggle('is-hidden', jobsTableVisible || footerVisible);
  };

  new IntersectionObserver(([entry]) => {
    jobsTableVisible = entry.isIntersecting;
    syncVisibility();
  }, { threshold: 0 }).observe(jobsTable);

  if (footer) {
    new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      syncVisibility();
    }, { threshold: 0 }).observe(footer);
  }
})();
